import { Button, Card, Divider } from '@ds';
import { parseTimeSpanToDurationString } from '@lp/features/Scheduler/utils';
import { AutoSchedulerInfo } from '@/api/apis/resources/schedule';
import { DotsProgress } from './DotsProgress';

type GenerationProcessCardProps = {
  isMutating?: boolean;
  generationInfo?: AutoSchedulerInfo | null;
  onGenerationCancel?: () => void;
};

export const GenerationProcessCard = ({
  isMutating,
  generationInfo,
  onGenerationCancel,
}: GenerationProcessCardProps) => {
  return (
    <Card className="w-[500px] mt-[180px] sticky top-[180px] py-6 px-10 bg-base-80 rounded-3xl border-none shadow-xl items-center">
      <h2 className="text-base-20 text-[28px]">Processing</h2>
      <div className="text-center text-base-25 text-s-r max-w-[320px] my-4">
        <span>Please wait while we set things up for you! The process might take up to 24 hours</span>
      </div>
      <Divider />
      <div className="flex gap-2 text-base-20 text-s-m my-3">
        <div className="flex flex-col items-center justify-between gap-2 min-h-[70px] p-3">
          <span>Processed Variants</span>
          {generationInfo ? <h4 className="text-hm">{generationInfo.foundSolutions}</h4> : <DotsProgress />}
        </div>
        <div className="flex flex-col items-center justify-between gap-2 min-h-[70px] p-3">
          <span>Validation Warnings</span>
          {generationInfo ? <h4 className="text-hm">{generationInfo.softRulesViolations}</h4> : <DotsProgress />}
        </div>
        <div className="flex flex-col items-center justify-between gap-2 min-h-[70px] p-3">
          <span>Optimization Time</span>
          {generationInfo ? (
            <h4 className="text-hm">{parseTimeSpanToDurationString(generationInfo.spendTime)}</h4>
          ) : (
            <DotsProgress />
          )}
        </div>
      </div>
      <Divider />
      <Button isLoading={isMutating} size="md" variant="outline" onClick={onGenerationCancel} className="mt-5">
        {generationInfo ? 'Stop with Available Result' : 'Cancel Generating'}
      </Button>
    </Card>
  );
};
